var apis = {
	// 服务系统配置
	"server_config": "https://ecash.meizu.com/public/sys_setting/server_config",
	'paypwd_get_status': 'https://jrpay.meizu.com/oauth/paypwd/get_status',
	// 开通-实名信息预填
	'identity_query': 'https://ecash.meizu.com/oauth/acct/identity/query',
	// 其他实名信息查询
	'identity_query_detail': 'https://ecash.meizu.com/oauth/acct/identity/query_detail',

	// 系统支持的银行卡列表接口V2.0
	'support_list': 'https://jrpay.meizu.com/oauth/secure/bank/support/list',
	// 用户银行卡列表接口
	'bank_list': 'https://jrpay.meizu.com/oauth/secure/bank/list',
	// 'bank_list': 'https://jrpay.meizu.com/oauth/bank/list',
	// 银行卡查询接口
	// 'bank_query': 'https://jrpay.meizu.com/oauth/bank/query',
	'bank_query': 'https://jrpay.meizu.com/oauth/secure/bank/query',
	// 银行卡发送验证码接口
	'bank_sms_code': 'https://jrpay.meizu.com/oauth/secure/bank/bind/vcode',
	// 'bank_sms_code': 'https://jrpay.meizu.com/oauth/bank/bind/vcode',
	// 重发绑卡验证码接口

	// 确认绑定银行卡接口
	'bank_bind': 'https://jrpay.meizu.com/oauth/secure/bank/bind',
	// 'bank_bind': 'https://jrpay.meizu.com/oauth/bank/bind',

	// 获取余额卡
	'acct_bank_get': 'https://ecash.meizu.com/oauth/acct/bank/get',

	// 用户风险评测等级接口
	'risk_grade_query': 'https://ecash.meizu.com/oauth/acctplus/risk_grade/query',
	// 用户风险评测题目列表接口
	'risk_grade_questions_list': 'https://ecash.meizu.com/oauth/acctplus/risk_grade/questions_list',
	// 用户风险评测答题接口
	'risk_grade_evaluate': 'https://ecash.meizu.com/oauth/user/risk_grade/evaluate',

	// 账户状态、资产查询
	'acct_query': 'https://ecash.meizu.com/oauth/acct/query',

	// 账单类型列表
	'order_type': 'https://ecash.meizu.com/oauth/order/type_list',
	// 我的账单（分页，基本搜索）
	'order_list': 'https://ecash.meizu.com/oauth/order/list',
	// 账单详情
	'order_detail': 'https://ecash.meizu.com/oauth/order/detail_query',

	// 开通-身份验证状态接口
	'identity_img_query': 'https://ecash.meizu.com/oauth/acctplus/identity_img/query',
	// 开通-身份验证信息上传接口
	'identity_img_upload': 'https://ecash.meizu.com/oauth/acctplus/identity_img/upload',

	// 余额转入/转出-订单创建
	'acct_order_create': 'https://ecash.meizu.com/oauth/acct/order/create',
	// 余额转入/转出-获取支付方式
	'acct_order_prepay': 'https://ecash.meizu.com/oauth/acct/order/prepay',
	// 余额转入/转出-订单支付
	'acct_order_pay': 'https://ecash.meizu.com/oauth/acct/order/pay',
	// 余额转入/转出-订单查询
	'acct_order_query': 'https://ecash.meizu.com/oauth/acct/order/query',
	// 余额+产品信息
	'acctplus_product_query': 'https://ecash.meizu.com/oauth/acctplus/product/query',

	// 转出订单预查询
	'order_prequery': 'https://ecash.meizu.com/oauth/acctplus/order/prequery',
	// 余额+转入/转出订单创建
	'acctplus_order_create': 'https://ecash.meizu.com/oauth/acctplus/order/create',
	// 余额+转入/转出-获取支付方式
	'acctplus_order_prepay': 'https://ecash.meizu.com/oauth/acctplus/order/prepay',
	// 余额+转入/转出订单支付
	'acctplus_order_pay': 'https://ecash.meizu.com/oauth/acctplus/order/pay',
	// 余额+转入/转出订单查询
	'acctplus_order_query': 'https://ecash.meizu.com/oauth/acctplus/order/query',
	// 收益明细
	'acctplus_profit_list': 'https://ecash.meizu.com/oauth/acctplus/profit_list',
	// 余额+预计日期
	'product_expected_date': 'https://ecash.meizu.com/oauth/acctplus/product/expected_date'

};

export default apis;



// WEBPACK FOOTER //
// ./src/apis.js